import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

import firebase from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCcIHGjf0wXo7nKdhR38KYFwT4QDTYprHs",
  authDomain: "iadr-4224d.firebaseapp.com",
  databaseURL: "https://iadr-4224d.firebaseio.com",
  projectId: "iadr-4224d",
  storageBucket: "iadr-4224d.appspot.com",
  messagingSenderId: "612415010078",
  appId: "1:612415010078:web:17b0df758695689c5b450f",
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage();
export const storageRef = storage.ref();

export default firebase;
